import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import EventEmitter from '../../utils/events'
import { isEqual } from 'lodash'
import store from '../../store'

// import Dragula from 'react-dragula'
import Dragula from '../../shared/components/Dragula'

// import styles
import './newworkscreen.scss'

// Constants

// Actions
import { triggerPopup, triggerPopupActionBG } from '../../actions/backdrop'
import { getOrdersNew, moveOrder, getOrdersAdvanced, startOrder, updateWorkscreenList, setOrdersFilter, getOrderSorting, mustOrderUpdateDueToSocket } from '../../actions/orders'
import { logOutAs, setPrevWorkscreen } from '../../actions/auth'
import { getOrderData } from '../../actions/assign'
import { openOverlay } from '../../actions/common'

// Utils
import { hasAccess, hasSubscriptionPermission, hasBodyShop, hasCombinedBodyPaintShop, hasPaintShop, hasAccessToAssign } from '../../utils/auth'
import { isFilterChanged, getOrderFilterData } from '../../utils/filter'
import { isTouchDevice } from '../../utils/detect'
import { translation } from '../../utils/helpers'

// import components
import Header from '../../shared/components/Header'
import Portal from '../../shared/components/Portal'
import MyTasks from '../MyPage/MyTasks'
import OverviewStatusSelection from '../../shared/components/OverviewStatusSelection'

// Elements
import Button from '../../shared/elements/button'
import Icon from '../../shared/elements/icon'
import { FilterIcons, MainMenuIcons, AssignmentIcons } from '../../shared/elements/icons'
import AddButton from '../../shared/elements/addButton'

// Modals
import MoveModal from '../../shared/modals/MoveModal'
import LoginAsModal from '../../shared/modals/LoginAsModal'
import QualityCheckModal from '../../shared/modals/QualityCheckModal'
import NewOrdersModal from '../../shared/modals/NewOrdersModal'
import MultiStartModal from '../../shared/modals/MultiStart'

// Item component
import Item from './Item'
import AssignItem from './AssignItem'
import AssignBox from './AssignBox'
import DropdownBox from './DropdownBox'
import SearchFilter from '../../shared/components/Search/SearchFilter'

import StopOtherOrders from '../../shared/components/StopOtherOrders'
import OrderCapacityOverview from '../../shared/overlays/OrderCapacityOverview'

class Workscreen extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'workscreen',
      steps: [],
      StepAssignments: [],
      moveItem: {
        open: false,
        type: 0,
        item: {}
      },
      loginasmodal: false,
      loginasmodalData: {},
      quality: {
        open: false,
        data: {},
        index: 0,
        pos: 0,
        move: true,
        onlyProcessComments: false
      },
      overviewstatusmodal: false,
      openDropdownLeft: false,
      screenview: '1',
      addPopupShow: false,
      addPopupClickedAsShop: false,
      openAction: false,
      openStartStop: false,
      filterOpen: false,
      searchFilter: {
        Screen: 'workscreen',
        SelectedWorkScreenType: 1,
        SimpleSearch: '',
        Steps: [],
        Process: {
          draft: false,
          draft1: false,
          draft2: false,
          InProcess: true,
          Completed: false
        }
      },
      initialSearchFilter: {
        Screen: 'workscreen',
        SelectedWorkScreenType: 1,
        Steps: [],
        Process: {
          draft: false,
          draft1: false,
          draft2: false,
          InProcess: true,
          Completed: false
        }
      },
      OpenstartModal: {
        open: false,
        step: 0
      },
      OrderStarts: {
        selectedOrderIds: [],
        selectedUserIds: [],
        Id: 0,
        first: true,
        start: false,
        larst: false
      },
      MoveOrders: {
        open: false,
        MoveAll: null,
        OrderIds: [],
        FromStep: 0,
        ToStep: 0,
        step: 0,
        index: 0,
        Id: 0
      },
      isIExplorer: false,
      isEdge: false,
      isFireFox: false,
      renderSteps: [],
      isLoadingFromInit: false,
      showTasks: false,
      pinTasks: false
    }
    this.md = new window.MobileDetect(window.navigator.userAgent)
    this.drake = null
    this.scroller = null
    this.events = null
    this.renderBoard = this.renderBoard.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.initiateMove = this.initiateMove.bind(this)
    this.closeMove = this.closeMove.bind(this)
    this.updateRow = this.updateRow.bind(this)
    this.handleRowUpdate = this.handleRowUpdate.bind(this)
    this.completeOrder = this.completeOrder.bind(this)
    this.onStartAsShopLogin = this.onStartAsShopLogin.bind(this)
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.closeLoginAs = this.closeLoginAs.bind(this)
    this.closeAssign = this.closeAssign.bind(this)
    this.getAssignOrderData = this.getAssignOrderData.bind(this)
    this.onAssignUsers = this.onAssignUsers.bind(this)
    this.initOrder = this.initOrder.bind(this)
    this.updateFromOrderSocket = this.updateFromOrderSocket.bind(this)
    this.renderDropdownLeft = this.renderDropdownLeft.bind(this)
    this.showAddPopup = this.showAddPopup.bind(this)
    this.openFilter = this.openFilter.bind(this)
    this.quickSearch = this.quickSearch.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.updateSteps = this.updateSteps.bind(this)
    this.updateRemainingTime = this.updateRemainingTime.bind(this)
    this.pressed = this.pressed.bind(this)
    this.closeOrderStart = this.closeOrderStart.bind(this)
    this.start = this.start.bind(this)
    this.setWorkscreenView = this.setWorkscreenView.bind(this)
    this.getVerticalScrollOffset = this.getVerticalScrollOffset.bind(this)
    this.getHorizontalScrollOffset = this.getHorizontalScrollOffset.bind(this)
    this.getScreenView = this.getScreenView.bind(this)
    this.orderMovedUpdateOrderSteps = this.orderMovedUpdateOrderSteps.bind(this)
    this.moveOrderSuccess = this.moveOrderSuccess.bind(this)
    this.app = null
    this.lock = false
    this.delta = 0
    this.lastDirection = null
    this.lastDelta = 0
    this.deltaX = 0
    this.canScroll = true
    this.moveOrders = this.moveOrders.bind(this)
    this.panHandler = this.panHandler.bind(this)
    this.toggleTasks = this.toggleTasks.bind(this)
    this.toggleTaskPin = this.toggleTaskPin.bind(this)
  }

  componentDidMount () {
    this.checkOpenCapacityOverview()
    this.lastDateUsed = false
    this._mounted = true
    // EventEmitter.addListener('WORKSCREEN_VIEW_CHANGED', this.setWorkscreenView, this)
    EventEmitter.removeListener('workcard_delete', this.handleDelete)
    EventEmitter.removeListener('update_row-workscreen', this.handleRowUpdate)
    EventEmitter.removeListener('updateorderlist', this.initOrder)
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromOrderSocket)
    EventEmitter.removeListener('ORDER_TIMES', this.updateRemainingTime)

    EventEmitter.addListener('workcard_delete', this.handleDelete, this)
    EventEmitter.addListener('update_row-workscreen', this.handleRowUpdate, this)
    EventEmitter.addListener('updateorderlist', this.initOrder, this)
    EventEmitter.addListener('ORDER_SOCKET', this.updateFromOrderSocket, this)
    EventEmitter.addListener('ORDER_TIMES', this.updateRemainingTime, this)

    this.reconnectSocket()
    this.setBodyClass(false)

    var isTouch = isTouchDevice()
    if (this.props.workscreenOrders.length === 0) {
      this.setWorkscreenView(true)
    }
    let filterData = getOrderFilterData({...this.props, source: 'workscreen'})
    // let filter = this.props.filter
    let filter = filterData.filter

    // if (isEqual(this.props.filter, this.props.initialFilter)) {
    //   let storedFilter = JSON.parse(window.localStorage.getItem('filterWorkscreen'))
    //   if (storedFilter !== undefined) {
    //     filter = storedFilter
    //   }
    // }
    // let simpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'))
    // // let simpleSearch = filterData.simpleSearch
    // if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value !== null && simpleSearch.value.length > 0) {
    //   filter.SimpleSearch = simpleSearch.value
    // }

    if (filterData.hasSimpleSearch) {
      filter.SimpleSearch = filterData.simpleSearch.value
    }

    this.setState({
      isIExplorer: navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1,
      isEdge: navigator.userAgent.indexOf('Edge') > -1,
      isFireFox: navigator.userAgent.indexOf('Firefox') > -1,
      isTouch: isTouch === true || Number(isTouch) > 0,

      showTasks: window.localStorage.getItem('workscreen_pin_tasks') === 'true',
      pinTasks: window.localStorage.getItem('workscreen_pin_tasks') === 'true',

      searchFilter: {...this.state.searchFilter, ...filter}
    })

    if (filter === undefined || filter === null || isEqual(filter, { NewOrdersFilter: 0 })) {
      filter = {...this.props.initialFilter}
    }
    this.props.setOrdersFilter({...filter, NewOrdersFilter: 0}, 'workscreen')

    // Check if need to open capacity overview
    let location = this.props.router.location
    if (location.query.destination && location.query.destination === 'capacityoverview') {
      this.props.openOverlay('OrderCapacityOverview')
      this.props.router.replace({...location, query: {}})   // Reset query to only trigger once.
    }
  }

  componentWillUnmount () {
    this.lastDateUsed = false
    this._mounted = false
    if (this.drake !== null) {
      this.drake.destroy()
    }
    if (this.scroller !== null) {
      this.scroller.destroy()
    }
    let steps = []
    this.props.updateWorkscreenList(steps)
    this.props.triggerPopupActionBG(false)
    EventEmitter.removeListener('WORKSCREEN_VIEW_CHANGED', this.setWorkscreenView)
    EventEmitter.removeListener('workcard_delete', this.handleDelete)
    EventEmitter.removeListener('update_row-workscreen', this.handleRowUpdate)
    EventEmitter.removeListener('updateorderlist', this.initOrder)
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromOrderSocket)
    EventEmitter.removeListener('ORDER_TIMES', this.updateRemainingTime)
    this.setBodyClass(true)
  }

  checkOpenCapacityOverview () {
    let routeItems = window.LocalstorageStack.all()
    let index = routeItems.length - 3
    if (routeItems && routeItems.length > 3 && routeItems[index].pathname === 'OrderCapacityOverview') {
      this.props.openOverlay('OrderCapacityOverview')
    }
  }

  checkForPopups () {
    let item = document.getElementsByClassName('poppedup')[0]
    if (item !== undefined) {
      let itembounding = item.getBoundingClientRect()
      let app = item.parentElement
      let itemparrent = item.parentElement
      let itemparrentBounding = itemparrent.getBoundingClientRect()
      while (app.className !== 'drag-content scrollbar') {
        app = app.parentElement
      }
      let windowWith = window.innerWidth
      let windowHeight = window.innerHeight
      if (itembounding.left < 0) {
        if (windowWith > ((itembounding.width * 2) + itembounding.left)) {
          item.style.left = 0
        } else {
          let margin = (windowWith - itembounding.width) / 2
          item.style.right = itembounding.left - margin
        }
      }

      if (itembounding.right < 0) {
        if (windowWith > ((itembounding.width * 2) + itembounding.right)) {
          item.style.right = 0
        } else {
          let margin = (windowWith - itembounding.width) / 2
          item.style.left = itembounding.right - margin
        }
      }

      if (itembounding.top < 0) {
        app.scrollTop = app.scrollTop + itembounding.top
      }
      let bottomOffset = windowHeight - (itembounding.top + itembounding.height)
      let topOffset = (itemparrentBounding.top - itembounding.height)
      if (bottomOffset < 0 && topOffset > 160) {
        item.style.bottom = '100%'
        item.style.top = 'auto'
      }
    }
  }
  setWorkscreenView (doInitOrder, props, fromNewUser) {
    if (props === undefined) props = this.props
    let screenView = this.getScreenView(props, fromNewUser)
    this.setState({
      screenview: '' + screenView,
      renderSteps: this.getStepsFromView(screenView),
      searchFilter: {
        ...this.state.searchFilter,
        SelectedWorkScreenType: parseInt(screenView)
      }
    }, () => {
      if (doInitOrder && this._mounted) {
        if (fromNewUser) {
          let filter = { ...props.initialFilter, SelectedWorkScreenType: parseInt(screenView) }
          setTimeout(() => { this.initOrder(screenView, filter) }, 100) // Fix to wait for reset filter dispatch to complete
        } else {
          this.initOrder(screenView)
        }
      }
      if (doInitOrder === false && this._mounted) {
        let addPopupShow = this.state.addPopupShow
        let addPopupClickedAsShop = this.state.addPopupClickedAsShop
        if (addPopupShow === false && addPopupClickedAsShop === true) {
          addPopupShow = addPopupClickedAsShop
          this.setState({
            addPopupShow: addPopupShow,
            addPopupClickedAsShop: !addPopupShow
          }, () => {
            // console.log('[NewWorkscreen][setWorkscreenView] addpopupshow', addPopupShow)
            if (this.state.addPopupShow) {
              this.props.triggerPopup(this.state.addPopupShow)
            }
          })
        }
      }
    })
  }
  getScreenView (props, fromNewUser) {
    let screenView = '0'
    let prevscreen
    if (props.auth.inactiveUsers[props.auth.inactiveUsers.length - 1] !== undefined) {
      prevscreen = props.auth.inactiveUsers[props.auth.inactiveUsers.length - 1].PrevWorkscreenView
      if (prevscreen !== undefined && prevscreen !== null && prevscreen !== 'null') {
        screenView = prevscreen
        // console.log('[NewWorkscreen] set prevscreen', screenView, props.auth)
      }
    }
    let storedView = window.localStorage.getItem('workscreen_view')
    if (typeof storedView !== 'undefined' && storedView !== null && storedView !== 'null') {
      screenView = storedView
      if (fromNewUser && parseInt(props.auth.user.WorkscreenView) === 7) {
        // console.log('[NewWorkscreen] fromNewUser', screenView, props.auth)
        screenView = props.auth.user.WorkscreenView
      }
      let storedDepartment = parseInt(window.localStorage.getItem('department_type'))
      if (storedDepartment !== parseInt(props.auth.user.DepartmentType)) {
        let view = '1'
        let department = parseInt(props.auth.user.DepartmentType)
        switch (department) {
          case 0:
            view = '0'
            break
          case 1:
            view = '2'
            break
          case 2:
            view = '1'
            break
        }
        screenView = view
      }

      // console.log('[NewWorkscreen] from stored view', screenView, prevscreen)
      // } else if (props.auth.user.hasLoggedInBefore && !this.state.gotViewFromUser) {
      //   screenView = props.auth.user.WorkscreenView
      //   this.setState({
      //     gotViewFromUser: true
      //   })
    } else {
      screenView = props.auth.user.WorkscreenView
      // console.log('[NewWorkscreen] from from user view', screenView, prevscreen, props.auth)
    }

    // Validate screen allowed
    let paintScreens = ['0', '3', '4']
    let bodyScreens = ['2', '6']
    let combinedScreens = ['1']
    // let anyScreens = ['5', '7']

    let hasPaintShopValue = hasPaintShop(props.auth)
    let hasBodyShopValue = hasBodyShop(props.auth)
    let hasCombinedBodyPaintShopValue = hasCombinedBodyPaintShop(props.auth)
    // console.log('hasPaintShopValue', hasPaintShopValue, ' hasBodyShopValue', hasBodyShopValue, ' hasCombinedBodyPaintShopValue', hasCombinedBodyPaintShopValue)

    let invalidScreen = false
    if (!hasPaintShopValue && paintScreens.indexOf(screenView) !== -1) {
      invalidScreen = true
    }
    if (!hasBodyShopValue && bodyScreens.indexOf(screenView) !== -1) {
      invalidScreen = true
    }
    if (!hasCombinedBodyPaintShopValue && combinedScreens.indexOf(screenView) !== -1) {
      invalidScreen = true
    }

    if (invalidScreen) {
      // console.log('invalid screen', screenView)
      if (hasCombinedBodyPaintShopValue) {
        screenView = 1
      } else if (hasPaintShopValue) {
        screenView = 0
      } else if (hasBodyShopValue) {
        screenView = 2
      }
    }

    window.localStorage.setItem('workscreen_view', screenView)
    // console.log('[NewWorkscreen] getScreenView end', screenView)
    return screenView
  }
  setBodyClass (out) {
    setTimeout(() => {
      if (out) {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('workscreen__body', '')
      } else {
        document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className + ' workscreen__body'
      }
    }, 0)
  }

  reconnectSocket () {
    if (window.sock.readyState === window.sock.OPEN) {
      let shopId = JSON.parse(window.localStorage.user_data).ShopId
      if (parseInt(shopId) === 0 && window.localStorage.loginAsUser) {
        shopId = JSON.parse(window.localStorage.loginAsUser).ShopId
      }
      window.sock.send(JSON.stringify({
        Type: 'RECONNECT',
        ShopId: parseInt(shopId)
      }))
    }
  }
  componentDidUpdate (prevProps, prevState) {
    // if (prevState.addPopupShow !== this.state.addPopupShow) {
    //   console.log('[NewWorkscreen][componentDidUpdate] addPopupShow', prevState.addPopupShow, this.state.addPopupShow)
    // }
    // if (prevState.addPopupClickedAsShop !== this.state.addPopupClickedAsShop) {
    //   console.log('[NewWorkscreen][componentDidUpdate] addPopupClickedAsShop', prevState.addPopupClickedAsShop, this.state.addPopupClickedAsShop)
    // }
  }
  componentWillReceiveProps (nextProps, nextState) {
    // console.log('recieved props', this._mounted, this.props.router.location.pathname)
    if (this._mounted === false || this.props.router.location.pathname !== '/workscreen') return
    this.lastDateUsed = false
    // let savedScreen = window.localStorage.getItem('workscreen_view')
    if (!isEqual(this.state.steps, nextProps.workscreenOrders) && isEqual(this.props.auth, nextProps.auth) && !nextProps.auth.prevWorkscreen && !this.props.auth.prevWorkscreen) {
      // console.log('[NewWorkscreen] revieced new workscreenOrders', nextProps.auth)
      this.setState({
        steps: nextProps.workscreenOrders
      }, () => this.setWorkscreenView(false, nextProps))
    } else if (!isEqual(this.props.auth.user, nextProps.auth.user) && !nextProps.auth.user.hasLoggedInBefore) {
      // console.log('[NewWorkscreen] revieced new user', nextProps.auth.user.WorkscreenView)
      this.setWorkscreenView(true, nextProps, true)
    } else if (nextProps.auth.prevWorkscreen !== undefined && nextProps.auth.prevWorkscreen !== null) {
      let screenView = nextProps.auth.prevWorkscreen
      window.localStorage.setItem('workscreen_view', screenView)
      store.dispatch(this.props.setPrevWorkscreen(null))
      this.setState({
        steps: nextProps.workscreenOrders
      }, () => {
        // console.log('[NewWorkscreen] set prevworkscreen', this.state)
      })
      // console.log('prevscreenview has value', screenView)
      // this.setState({
      //   screenview: '' + screenView,
      //   renderSteps: this.getStepsFromView(screenView),
      //   searchFilter: {
      //     ...this.state.searchFilter,
      //     SelectedWorkScreenType: parseInt(screenView)
      //   }
      // }, () => {
      //   this.props.setPrevWorkscreen(null)
      // })
    }
  }

  openFilter () {
    this.setState({
      filterOpen: !this.state.filterOpen
    }, () => {
      if (this.state.filterOpen) {
        if (this.refs.SearchFilter.getWrappedInstance().refs.simpleSearch !== undefined) {
          this.refs.SearchFilter.getWrappedInstance().refs.simplesearch.focus()
        }
      }
    })
  }

  quickSearch (val) {
    // console.log('workscreen quickSearch', val)
    this.setState({
      isLoading: true,
      filterOpen: false,
      searchFilter: {
        Screen: 'workscreen',
        SelectedWorkScreenType: parseInt(this.state.screenview),
        SimpleSearch: val,
        SkipCheck: true
      }
    }, () => {
      this.initOrder()
    })
  }

  onSearchSubmit (filter) {
    // console.log('workscreen onSearchSubmit', filter)
    this.setState({
      isLoading: true,
      filterOpen: false,
      searchFilter: {
        ...filter,
        Screen: 'workscreen',
        SelectedWorkScreenType: parseInt(this.state.screenview),
        movedOrders: false,
        process: {
          InProcess: true
        }
      }
    }, () => {
      this.initOrder()
    })
  }

  updateRemainingTime (json) {
    let steps = [...this.state.steps]
    steps.map((step, key) => {
      if (['1', '2', '3', '4', '5', '6', '7', '101', '102', '103', '104'].includes(step.Title)) {
      // if (step.Title === '1' || step.Title === '2' || step.Title === '3' || step.Title === '4' ||
      //   step.Title === '5' || step.Title === '6' || step.Title === '7') {
        step.Orders.map((order, orderKey) => {
          if (order.IsStarted) {
            json.Data.map((remainingTime, timeKey) => {
              if (order.Id === remainingTime.OrderId) {
                order.RemainingTimeDelay = remainingTime.Delay
                order.ColoredParts = remainingTime.ColoredParts
              }
            })
          }
        })
      }
    })
    // this.setState({
    //   steps: steps
    // })
    this.setState(prevState => ({
      steps: steps
    }))
  }

  updateFromOrderSocket (json) {
    // console.log('workscreen updateFromOrderSocket', json)
    switch (json.Type) {
      case 'ORDER_UPDATE':
        this.updateSingleOrder(json.Data)
        break
      case 'ORDER_STARTED':
      case 'ORDER_STOPPED':
        this.updateMultipleOrders(json.Data)
        break
      case 'ORDER_MOVED':
        if (json.Data.MovedOrderIds !== undefined || json.Data.MovedOrderId !== undefined) {
          // if (this.props.auth.user.DeviceToken === json.DeviceToken) console.log('Request came from my client!')
          if (this.props.auth.user === undefined || this.props.auth.user.DeviceToken === undefined || this.props.auth.user.DeviceToken === null || this.props.auth.user.DeviceToken !== json.DeviceToken) {
            this.orderMovedUpdateOrderSteps(json.Data)
          }
        } else {
          this.updateOrderSteps(json.Data.data)
        }
        break

      default:
        // console.log(json.Data)
        // console.log('DEFAULT SOCKET HANDLING: (updateOrderSteps)')
        if (json.Data.data !== undefined) {
          this.updateOrderSteps(json.Data.data)
        } else {
          this.updateOrderSteps(json.Data)
        }
        break
    }
  }

  updateMultipleOrders (data) {
    // console.log('workscreen updateMultipleOrders', data)
    if (data.OrderIds === undefined || data.OrderIds === null || data.OrderIds.length === 0) return
    let filter = {
      ...this.state.searchFilter,
      identification: {
        ordernumbers: data.OrderIds
      }
    }
    this.props.getOrdersNew(filter).then((res) => {
      let resultSteps = res.data[0].Steps
      let stepsOriginal = [...this.state.steps]
      resultSteps.map((resultStep, key) => {
        resultSteps[key].Orders.map((v, k) => {
          // Find step in stepsOriginal
          let stepsOriginalIndex = stepsOriginal.findIndex(s => s.StepId === resultStep.StepId)
          if (stepsOriginalIndex !== -1) {
            // Find order in step
            let orderIndexOriginal = stepsOriginal[stepsOriginalIndex].Orders.findIndex((o) => { return o.Id === v.Id })
            if (orderIndexOriginal !== -1) {
              stepsOriginal[stepsOriginalIndex].Orders[orderIndexOriginal] = {
                ...v,
                mathRandom: Math.random()
              }
            }
          }
        })
      })
      this.setState(prevState => ({
        steps: stepsOriginal
      }))
    })
  }

  updateSingleOrder (data) {
    let steps = [...this.state.steps]
    // check if the order must be update
    if (!mustOrderUpdateDueToSocket([data.Id], steps)) return

    let selectedStep
    steps.map((step) => {
      if (step.StepId === data.StepId) {
        selectedStep = step
      }
    })

    if (typeof selectedStep !== 'undefined') {
      let getFromServer = data.IsUpdateRequired !== undefined && data.IsUpdateRequired === true
      if (getFromServer) {
        let filter = {
          ...this.state.searchFilter,
          identification: {
            ordernumber: {
              value: data.Id,
              option: 1
            }
          }
        }
        // console.log('Call getOrdersNew from updateSingleOrder')
        this.props.getOrdersNew(filter).then((res) => {
          // console.log('UPDATE SINGLE ORDER', res.data)
          let searchSteps = res.data[0].Steps
          let foundOrder = null
          for (let s = 0; s < searchSteps.length; s++) {
            if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
              for (let o = 0; o < searchSteps[s].Orders.length; o++) {
                if (searchSteps[s].Orders[o].Id === data.Id) {
                  foundOrder = searchSteps[s].Orders[o]
                  break
                }
              }
            }
            if (foundOrder !== null) break
          }

          // Insert new order data...
          selectedStep.Orders = selectedStep.Orders.map((order) => {
            if (foundOrder !== null && order.Id === foundOrder.Id) {
              let orderCopy = { ...order }
              orderCopy.Id = foundOrder.Id
              orderCopy.IsStarted = foundOrder.IsStarted
              orderCopy.StepId = foundOrder.StepId
              orderCopy.Employees = foundOrder.Employees
              orderCopy.Model = foundOrder.Model
              orderCopy.RegNumber = foundOrder.RegNumber
              orderCopy.Transport = foundOrder.Transport
              orderCopy.IsLinkMain = foundOrder.IsLinkMain
              orderCopy.PreviouslyStarted = foundOrder.PreviouslyStarted
              orderCopy.InspectionStepsCompleted = foundOrder.InspectionStepsCompleted
              orderCopy.InspectionStepsTotal = foundOrder.InspectionStepsTotal
              orderCopy.DisplayedTimePrt1 = foundOrder.DisplayedTimePrt1
              orderCopy.DisplayedTimePrt2 = foundOrder.DisplayedTimePrt2
              orderCopy.CustomerName = foundOrder.CustomerName
              orderCopy.HasNotes = foundOrder.HasNotes
              orderCopy.UnreadNotes = foundOrder.UnreadNotes
              orderCopy.ColorIsReady = foundOrder.ColorIsReady
              orderCopy.MissingParts = foundOrder.MissingParts
              orderCopy.ColorVariant = foundOrder.ColorVariant
              orderCopy.IsStopped = foundOrder.IsStopped
              orderCopy.StoppedMessage = foundOrder.StoppedMessage
              orderCopy.OrderStop = foundOrder.OrderStop
              orderCopy.BodySparePartStatusSum = foundOrder.BodySparePartStatusSum
              orderCopy.PaintSparePartStatusSum = foundOrder.PaintSparePartStatusSum
              orderCopy.mathRandom = Math.random()
              order = orderCopy
            }
            return order
          })
          this.setState(prevState => ({
            steps: steps
          }))
        })
      } else {
        // console.log('Update order', data.Id, 'with', data)
        selectedStep.Orders = selectedStep.Orders.map((order) => {
          if (order.Id === data.Id) {
            let orderCopy = { ...order }
            orderCopy.Id = data.Id
            orderCopy.IsStarted = data.IsStarted
            orderCopy.StepId = data.StepId
            orderCopy.Employees = data.Employees
            orderCopy.Model = data.Model
            orderCopy.RegNumber = data.RegNumber
            orderCopy.Transport = data.Transport
            orderCopy.IsLinkMain = data.IsLinkMain
            orderCopy.PreviouslyStarted = data.PreviouslyStarted
            orderCopy.InspectionStepsCompleted = data.InspectionStepsCompleted
            orderCopy.InspectionStepsTotal = data.InspectionStepsTotal
            orderCopy.DisplayedTimePrt1 = data.DisplayedTimePrt1
            orderCopy.DisplayedTimePrt2 = data.DisplayedTimePrt2
            orderCopy.CustomerName = data.CustomerName
            orderCopy.HasNotes = data.HasNotes
            orderCopy.ColorIsReady = data.ColorIsReady
            orderCopy.ColorVariant = data.ColorVariant
            orderCopy.IsStopped = data.IsStopped
            orderCopy.StoppedMessage = data.StoppedMessage
            orderCopy.mathRandom = Math.random()
            order = orderCopy
          }
          return order
        })
        this.setState(prevState => ({
          steps: steps
        }))
      }
    }
  }

  stepHasComments (data) {
    let ProcessComments = data.ProcessComments
    let anyComments = false
    if (ProcessComments) {
      ProcessComments.map((val) => {
        if (val.StepComments.length !== 0) anyComments = true
      })
    } else if (data.Checks) {
      data.Checks.map((check) => {
        check.ProcessComments.map((val) => {
          if (val.StepComments.length !== 0) anyComments = true
        })
      })
    }

    return anyComments
  }

  getStepsFromView (view) {
    if (view === undefined) view = this.state.screenview
    switch (view) {
      case '0':
        return [1, 5, 6, 7, 8, 10, 14]
      case '1':
        return []
      case '2':
        return [1, 2, 3, 4, 11, 12, 13, 14]
      case '3':
        return [1, 5, 6, 7, 8]
      case '4':
        return [1, 7, 8, 10, 14]
      case '5':
        return [1, 10, 14]
      case '6':
        return [2, 3, 4, 11, 13]
      case '7':
        if (!this.props.auth.myscreen.Active) {
          return []
        } else {
          let activeSteps = []
          let screenValues = [
            { val: 1, step: 1 },
            { val: 2, step: 5 },
            { val: 3, step: 6 },
            { val: 4, step: 7 },
            { val: 5, step: 8 },
            { val: 6, step: 10 },
            { val: 7, step: 14 },
            { val: 101, step: 2 },
            { val: 102, step: 3 },
            { val: 103, step: 11 },
            { val: 104, step: 13 }
          ]
          screenValues.map((screen) => {
            if (this.props.auth.myscreen['Step' + screen.val]) {
              activeSteps.push(screen.step)
            }
          })
          return activeSteps
        }
      default:
        return []
    }
  }

  orderMovedUpdateOrderSteps (data) {
    // console.log('ORDER-MOVED-UPDATE-ORDER-STEPS', data)
    let steps = [...this.state.steps]
    let selectedMovedFromStep
    let selectedMovedToStep
    steps.map((step) => {
      if (step.StepId === data.MovedTo) {
        selectedMovedToStep = step
      } else if (step.StepId === data.MovedFrom) {
        selectedMovedFromStep = step
      }
    })

    let orderIds = data.MovedOrderIds !== undefined ? data.MovedOrderIds : [data.MovedOrderId]
    // check if the order must be update
    if (!mustOrderUpdateDueToSocket(orderIds, steps)) return

    let filter = {
      ...this.state.searchFilter,
      identification: {
        OrderNumbers: orderIds
      }
    }

    this.props.getOrdersNew(filter).then((res) => {
      let searchSteps = res.data[0].Steps
      for (let i = 0; i < orderIds.length; i++) {
        let orderId = orderIds[i] + ''
        let foundOrder = null
        for (let s = 0; s < searchSteps.length; s++) {
          if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
            for (let o = 0; o < searchSteps[s].Orders.length; o++) {
              if (searchSteps[s].Orders[o].OrderKey === orderId && searchSteps[s].Orders[o]) {
                foundOrder = searchSteps[s].Orders[o]
                break
              }
            }
          }
          if (foundOrder !== null) break
        }

        // Remove order in 'moved from' step
        if (selectedMovedFromStep !== undefined) {
          let indexInFrom = selectedMovedFromStep.Orders.findIndex(order => order.OrderKey === orderId)
          if (indexInFrom >= 0) {
            selectedMovedFromStep.Orders.splice(indexInFrom, 1)
          }
        }

        if (foundOrder !== null) {
          // Insert order in 'moved to' step (remove first if already inserted)
          if (selectedMovedToStep !== undefined) {
            let indexInTo = selectedMovedToStep.Orders.findIndex(order => order.Id === foundOrder.Id)
            let doInsert = true
            if (indexInTo >= 0) {
              doInsert = false
              let orderInTo = selectedMovedToStep.Orders[indexInTo]
              if (!foundOrder.IsDisplayOnly || orderInTo.IsDisplayOnly) { // If exists in step, only replace if old is displayOnly or new is not displayOnly
                selectedMovedToStep.Orders.splice(indexInTo, 1)
                doInsert = true
              }
            }
            if (doInsert) {
              selectedMovedToStep.Orders.push(foundOrder)
              foundOrder.mathRandom = Math.random()
            }
          }
        }
      }

      if (selectedMovedToStep !== undefined) {
        let toStepOrderKeys = selectedMovedToStep.Orders.map(o => o.OrderKey)
        let step = selectedMovedToStep.StepId

        this.props.getOrderSorting(step, toStepOrderKeys).then((res) => {
          selectedMovedToStep.Orders.sort((orderA, orderB) => {
            return res.data.findIndex(orderKey => orderKey === orderA.OrderKey) - res.data.findIndex(orderKey => orderKey === orderB.OrderKey)
          })
          this.setState(prevState => ({
            steps: steps
          }))
        })
      } else {
        this.setState(prevState => ({
          steps: steps
        }))
      }
    })
  }

  updateOrderSteps (data) {
    let searchData = {
      Steps: data,
      Process: {
        draft: false,
        draft1: false,
        draft2: false,
        InProcess: true,
        Completed: false
      }
    }
    /*
    this.setState({
      searchFilter: {
        ...this.state.searchFilter,
        Steps: data
      }
    })
    */
    searchData = this.state.searchFilter
    searchData = {
      ...searchData,
      Steps: data
    }
    // console.log('Call getOrdersNew from updateOrderSteps')
    this.props.getOrdersNew(searchData).then((res) => {
      let steps = res.data[0].Steps
      let stepsOriginal = [...this.state.steps]
      stepsOriginal.map((step, key) => {
        // if (data.indexOf(parseInt(step.Title)) !== -1) {
        if (data.indexOf(step.StepId) !== -1) {
          stepsOriginal[key].Orders = steps[key].Orders
          stepsOriginal[key].Orders.map((v, k) => {
            stepsOriginal[key].Orders[k] = {
              ...v,
              mathRandom: Math.random()
            }
          })
        }
        return step
      })
      this.setState(prevState => ({
        steps: stepsOriginal
      }))
    })
  }

  debindAll () {
    if (this.drake !== null) { this.drake.destroy() }
    if (this.scroller !== null) { this.scroller.destroy() }
    let hammerTime = new window.Hammer(window.board, {
      inputClass: window.Hammer.TouchInput
    })
    hammerTime.off('swipeleft')
    hammerTime.off('swiperight')
  }

  initOrder (overrideScreenView = null, filterOverride = null) {
    if (this.state.isLoadingFromInit || !this._mounted || this.props.router.location.pathname !== '/workscreen') return this
    this.debindAll()
    this.setState({
      steps: [],
      isLoadingFromInit: true
    })
    // let steps = this.getStepsFromView()
    // let data = {
    //   Steps: [],
    //   SelectedWorkScreenType: overrideScreenView !== null ? parseInt(overrideScreenView) : parseInt(this.getScreenView(this.props)),
    //   Process: {
    //     draft: false,
    //     draft1: false,
    //     draft2: false,
    //     InProcess: true,
    //     Completed: false
    //   }
    // }

    let data = { ...this.state.searchFilter } // don't know why 'data' was assigned twice (?)
    if (overrideScreenView !== null) {
      data.SelectedWorkScreenType = parseInt(overrideScreenView)
    }

    if (filterOverride !== undefined && filterOverride !== null) {
      data = filterOverride
    }

    // Trigger popup action BG - START
    this.props.triggerPopupActionBG(true)
    // Trigger popup action BG - END
    // console.log('Call getOrdersNew from initOrder')
    return this.props.getOrdersNew(data).then((res) => {
      // Trigger popup action BG - START
      this.props.triggerPopupActionBG(false)
      // Fix for when moving an order after loginas popup
      if (this.state.moveItem.open) {
        this.props.triggerPopup(true)
      }

      if (!this._mounted) return null
      // Trigger popup action BG - END
      let steps = res.data[0].Steps
      this.props.updateWorkscreenList(steps)
      this.setState({
        // steps: steps,
        view: (typeof this.props.location.query.view !== 'undefined') ? this.props.location.query.view : 'workscreen',
        isLoadingFromInit: false,
        isLoading: false
      }, () => {
        if (typeof this.props.location.query.view !== 'undefined') {
          this.getAssignOrderData()
          this.props.router.replace('/workscreen')
        } else {
          // setTimeout(() => {
          this.initDragula(steps)
          this.initHammer()
          // }, 0)
        }
      })
      return res
    }).catch(_ => {
      this.props.triggerPopupActionBG(false)
      window.toastr.error(translation('18079'), translation('216'))
    })
  }

  // Updates order data from the API for the given steps
  updateSteps (steps) {
    let filter = { ...this.state.searchFilter }
    filter.Steps = steps
    // console.log('Call getOrdersNew from updateSteps')
    return this.props.getOrdersNew(filter).then((res) => {
      let stepsUpdate = res.data[0].Steps

      // TODO: færdiggør den her..
      let stepsData = [...this.state.steps]
      for (var i = 0; i < stepsData.length; i++) {
        for (var j = 0; j < stepsUpdate.length; j++) {
          if (steps.filter((s) => {
            // console.log('s', s, 'stepsUpdate[' + j + '].Title', stepsUpdate[j].Title)
            return s === parseInt(stepsUpdate[j].Title)
          }) && stepsUpdate[j].Title === stepsData[i].Title) {
            stepsData[i] = stepsUpdate[j]
          }
        }
      }
      this.setState({
        steps: stepsData
      })
    })
  }

  handleDelete (event) {
    let steps = [...this.state.steps]
    delete steps[event.step].Orders[event.index]
    this.setState({
      steps: steps
    })
  }

  allowHammer () {
    let allowSize = window.innerWidth < 1367
    let androidTablet = (this.md.is('AndroidOS') && this.md.tablet() !== null)
    if (this.state.isTouch && !androidTablet && allowSize) {
      return true
    }
    return false
  }
  panHandler (event) {
    if (event.type === 'panend' || event.type === 'pancancel') {
      // iOS bug fix
      this.lock = false
      this.delta = 0
      this.lastDirection = null
      this.lastDelta = 0
      this.deltaX = 0
    } else if ((event.type === 'swipe' || event.type === 'panmove') && event.direction & window.Hammer.DIRECTION_VERTICAL) {
      this.lock = true
    } else if (event.type === 'swipe' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
      // iOS bug fix
      this.lock = true
    } else if (event.type === 'panmove' && event.direction & window.Hammer.DIRECTION_HORIZONTAL) {
      if (this.lastDirection === null) {
        this.lastDirection = event.direction
      }
      this.deltaX = event.deltaX
      if (window.board.scrollLeft >= window.board.width) window.board.scrollLeft = window.board.width
      if (window.board.scrollLeft < 0) window.board.scrollLeft = 0
      if (this.lock === true ||
        !this.canScroll ||
        window.board.scrollLeft > window.board.width ||
        window.board.scrollLeft < 0 ||
        (this.deltaX === this.lastDelta && window.board.scrollLeft > 0)
      ) return
      if (this.lastDirection !== event.direction) {
        this.delta = this.deltaX - this.lastDelta
        window.board.scrollLeft -= this.delta
      } else {
        this.delta = this.lastDelta - this.deltaX
        window.board.scrollLeft += this.delta
      }
      this.lastDirection = event.direction
      this.lastDelta = this.deltaX
    }
  }

  initHammer () {
    // if (this.md.userAgent() === 'Safari' || this.md.phone()) {
    if (!this.allowHammer()) return null

    // const getPos = () => {
    //   if (typeof window.board.dataset.pos === 'undefined') {
    //     return 1
    //   }
    //   return parseInt(window.board.dataset.pos)
    // }
    // let hammerTime = new window.Hammer(window.board, {
    //   inputClass: window.Hammer.TouchInput
    // })
    // if (window.innerHeight < 600 || window.innerWidth < 600) {
    //   hammerTime.on('swipeleft', (ev) => {
    //     let newPos = (getPos() !== this.state.steps.length) ? (getPos() + 1) : getPos()
    //     this.changePage(newPos)
    //   })
    //   hammerTime.on('swiperight', (ev) => {
    //     let newPos = (getPos() > 1) ? (getPos() - 1) : getPos()
    //     this.changePage(newPos)
    //   })
    // } else {
      // hammerTime.add(new window.Hammer.Pan({ direction: window.Hammer.DIRECTION_HORIZONTAL, threshold: 10 }))
      // hammerTime.on('panstart panmove panend pancancel swipe', this.panHandler)
    // }
  }
  changePage (pos) {
    window.board.dataset.pos = pos
    pos = parseInt(pos) - 1
    let parent = this.refs['dragparent' + pos]
    window.board.scrollLeft = parent.offsetLeft - 5
  }

  updateRow (data, pos, index) {
    let stepsCopy = [...this.state.steps]
    // let nKey = 0
    stepsCopy.map((val, key) => {
      if (val.Title === data.Title) {
        // nKey = key
        stepsCopy[key] = data
      }
    })

    /*     if (pos !== undefined && index !== undefined) { // Added for some cases where pos and index are undefined to avoid errors preventing setState to be called
      stepsCopy[pos].Orders.splice(index, 1)
    } */
    this.setState({
      steps: stepsCopy
    })
    // Toastr
    // window.toastr.success(translation('1909'), translation('13424'))
    // Change page if phone
    // if (this.md.userAgent() === 'Safari' || this.md.phone()) {
    // if (this.allowHammer()) {
    //   this.changePage(nKey + 1)
    // }
  }

  handleRowUpdate (event) {
    if (event.data !== undefined) this.updateRow(event.data, event.pos, event.index)
  }

  moveOrders (data) {
    // console.log('state data', this.state.MoveOrders)
    if (data === undefined) {
      data = {
        OrderIds: this.state.MoveOrders.MoveAll === true ? this.state.MoveOrders.OrderIds : [this.state.MoveOrders.Id],
        UserId: 0,
        StepFrom: this.state.MoveOrders.FromStep,
        StepTo: this.state.MoveOrders.ToStep,
        Comment: '',
        FilterSettings: {}
      }
      this.setState({
        MoveOrders: {
          ...this.state.MoveOrders,
          MoveAll: null
        }
      })
      // console.log('data', data)
    }

    // console.log('moveOrders (data): ', data)
    let orders = []
    for (let i = 0; i < data.OrderIds.length; i++) {
      let order = {
        OrderId: data.OrderIds[i]
      }
      orders.push(order)
    }

    let moveData = {
      Orders: orders,
      UserId: data.UserId,
      StepFrom: data.StepFrom,
      StepTo: data.StepTo,
      Comment: data.Comment,
      FilterSettings: data.FilterSettings,
      MoveAll: data.MoveAll === undefined ? this.state.MoveOrders.MoveAll : data.MoveAll,
      CheckOnly: false
    }

    this.props.moveOrder(moveData).then((res) => {
      if (res.data.MoveAll) {
        // console.log('moveALL')
        this.setState({
          MoveOrders: {
            ...this.state.MoveOrders,
            open: true,
            MoveAll: null,
            OrderIds: res.data.OrderIds,
            FromStep: moveData.StepFrom, // res.data.StepFrom,
            ToStep: moveData.StepTo, // res.data.StepTo,
            Id: data.OrderIds[0]
          }
        }, () => {
          return null
        })
      } else if (res.data.Checks.length > 0 && res.data.Checks.some(x => x.MoveFailed)) {
        this.props.triggerPopup(true)
        res.data.OrderIds = data.OrderIds
        this.setState({
          quality: {
            open: true,
            data: [res.data],
            pos: data.Pos,
            index: data.Index,
            move: true
          },
          MoveOrders: {
            ...this.state.MoveOrders,
            FromStep: moveData.StepFrom
          }
        })
      } else {
        if (this.stepHasComments(res.data)) {
          this.props.triggerPopup(true)
          this.setState({
            quality: {
              open: true,
              data: [res.data],
              pos: data.Pos,
              index: data.Index,
              move: true,
              onlyProcessComments: true
            }
          })
        } // else {
        // let message = orders.length > 1 ? translation('12338') : translation('1909')
        // window.toastr.success(message, translation('13424'))
        if (res.data.MoveFailed === false) {
          this.moveOrderSuccess(res.data, moveData.Orders)
        }
        // }
        // this.updateRow(res.data.CurrentStepOrders, data.Pos, data.Index)
      }
    }, (res) => {
      // Toastr
      let message
      if (res.response.data.IsStopped === true) message = translation('12347')
      else if (res.response.data.IsReffered === true) message = translation('2704')
      else message = orders.length > 1 ? translation('12339') : translation('1731')

      // Get error message from response.
      if (res.response.data !== undefined && res.response.data.DictionaryKey !== undefined) {
        message = translation(res.response.data.DictionaryKey)
      }

      // If have StatusCode = 1 (Order can not be moved to this step)
      if (res.response.data !== undefined && res.response.data.StatusCode !== undefined) {
        let statusCode = res.response.data.StatusCode
        if (statusCode === 1) {
          // this.moveOrders(this.state.MoveOrders) // Made mass error message spam...
        }
      }

      window.toastr.error(message, translation('216'))
    })
  }

  initDragula (steps) {
    // Containers
    let containers = []
    for (let i = 0; i < steps.length; i++) {
      containers.push(this.refs['drag-container' + i])
    }
    // Options
    let options = {
      threshold: {
        y: 68,
        x: 50
      },
      ignoreInputTextSelection: false,
      direction: 'horizontal',
      revertOnSpill: true,
      copy: true,
      accepts: (el, target, source, sibling) => {
        return target.dataset.pos !== source.dataset.pos
      },
      moves: (el, source, handle, sibling) => {
        if (handle.classList.contains('upcomingOrders')) return false
        if (this.state.isTouch) {
          // let triggerOpen = ['action__menu', 'action_opener', 'action_image', 'buttons', 'workers', 'worker__image', 'workers_name']
          let triggerOpen = ['action__menu', 'action_opener', 'action_opener actionSwipe', 'action_image', 'action_image actionSwipe']

          return triggerOpen.indexOf(handle.className) !== -1 && !this.props.modalOpen
        }
        return !this.props.modalOpen
      },
      invalid: (el, handle) => {
        if (el.classList.contains('locked')) {
          return true
        }

        let excludeClasses = ['hint--bottom', 'workers', 'buttons']
        return excludeClasses.indexOf(handle.className) !== -1 || typeof handle.dataset.action !== 'undefined'
        // if (excludeClasses.indexOf(handle.className) !== -1) return true
        // if (typeof handle.dataset.action !== 'undefined') return true
        // return false
      }
    }
    const preventDefault = (e) => {
      e = e || window.event
      if (e.preventDefault) e.preventDefault()
      e.returnValue = false
      e.passive = true
    }
    const preventDefaultForScrollKeys = (e) => {
      let keys = {
        37: 1,
        38: 1,
        39: 1,
        40: 1
      }
      if (keys[e.keyCode]) {
        preventDefault(e)
        return false
      }
    }
    const disableScroll = () => {
      this.canScroll = false
      if (window.addEventListener) {
        window.removeEventListener('DOMMouseScroll', preventDefault, false)
        window.addEventListener('DOMMouseScroll', preventDefault, false)
      }
      window.onwheel = preventDefault // modern standard
      window.onmousewheel = document.onmousewheel = preventDefault // older browsers, IE
      window.ontouchmove = preventDefault // mobile
      document.onkeydown = preventDefaultForScrollKeys
    }
    const enableScroll = () => {
      if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false)
      window.onmousewheel = document.onmousewheel = null
      window.onwheel = null
      window.ontouchmove = null
      document.onkeydown = null
      this.canScroll = true
    }
    // Dragula
    let drake = null
    if (this.drake !== null) {
      this.drake.destroy()
    }
    this.drake = drake = new Dragula(containers, options)
      // .on('threshold_drag', () => {
      //   disableScroll()
      //   setTimeout(() => {
      //     enableScroll()
      //   }, 100)
      // })
      .on('drag', (el, source) => {
        if (this.canScroll) disableScroll()
      })
      .on('over', (el, container) => {
        let parent = this.refs['dragparent' + container.dataset.pos]
        if (parent.className.indexOf(' ex-over') === -1) parent.className += ' ex-over'
      })
      .on('out', (el, container) => {
        let parent = this.refs['dragparent' + container.dataset.pos]
        if (parent.className.indexOf(' ex-over') > -1) parent.className = parent.className.replace(' ex-over', '')
      })
      .on('shadow', (el, target) => {
        if (el.style.display !== 'none') el.style.display = 'none'
      })
      .on('drop', (el, target, source, sibling) => {
        if (!this.canScroll) enableScroll()
        if (el.style.display !== 'block') el.style.display = 'block'
        this.initiateMove(el, target, source, sibling)
        drake.cancel()
      })
      .on('cancel', (el, container) => {
        enableScroll()
        el.style.display = 'block'
        // setTimeout(() => {
        //   if (this.allowHammer()) {
        //     this.changePage(parseInt(container.dataset.pos) + 1)
        //   }
        // }, 0)
      })
    // Auto scroll
    this.scroller = window.autoScroll(
      [
        window,
        this.refs.board
      ],
      {
        margin: 150,
        maxSpeed: 10,
        scrollWhenOutside: true,
        autoScroll: function () {
          // return this.down && drake.dragging
          return drake.dragging
        }
      }
    )
  }

  closeMove () {
    this.setState({
      moveItem: {
        open: false,
        type: 0,
        item: {}
      }
    })
    this.props.triggerPopup(false)
  }

  // initiateMove (el, pos1, pos2, sourceStepId, targetStepId)
  initiateMove (el, target, source, sibling, oneStepMoveItem = null) {
    // Difference
    const difference = (a, b) => {
      return Math.abs(a - b)
    }

    // console.log('source.dataset', source.dataset, 'target.dataset', target.dataset)
    let drake = this.drake
    let pos1 = parseInt(source.dataset.pos)
    let pos2 = parseInt(target.dataset.pos)
    let sourceStepId = parseInt(source.dataset.stepid)
    let targetStepId = parseInt(target.dataset.stepid)
    let index = parseInt(el.dataset.index)
    let item = oneStepMoveItem || { ...this.state.steps[pos1].Orders[index] }

    if (this.props.auth.departmentType !== 1 && pos1 > pos2 && !(hasAccess([7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30) || hasSubscriptionPermission(this.props.auth, 30, 20))) {
      window.toastr.error(translation('17864'), translation('216'))
      return null
    }

    if (difference(pos1, pos2) === 1 && pos2 > pos1) {
      if (hasAccess([5, 7], this.props.auth.user.UserType)) {
        this.onStartAsShopLogin({
          type: 'move',
          isOneStepMove: true,
          item: item,
          move: {
            el: el,
            target: target,
            source: source,
            sibling: sibling
          },
          quality: {
            open: true,
            pos: pos1,
            index: index
          }
        })
        drake.cancel()
        return false
      }

      let data = {
        OrderIds: [item.Id],
        UserId: 0,
        StepFrom: sourceStepId,
        StepTo: targetStepId,
        Comment: '',
        FilterSettings: {}
      }

      this.setState({
        MoveOrders: {
          ...this.state.MoveOrders,
          MoveAll: null
        }
      }, () => {
        this.moveOrders(data)
      })
    } else {
      let moveData = {
        Orders: [
          {
            OrderId: item.Id
          }
        ],
        UserId: 0,
        StepFrom: sourceStepId,
        StepTo: targetStepId,
        Comment: '',
        FilterSettings: {},
        CheckOnly: true
      }

      if (hasAccess([5, 7], this.props.auth.user.UserType)) {
        this.onStartAsShopLogin({
          type: 'move',
          move: moveData,
          quality: {
            open: true,
            pos: pos1,
            index: index
          },
          stepid: targetStepId,
          pos1: pos1,
          pos2: pos2,
          index: index,
          item: item
        })
        drake.cancel()
        return false
      }

      this.props.moveOrder(moveData).then((res) => {
        item.NewStepId = targetStepId
        item.StepIndex = pos1
        item.ItemIndex = index
        let type = (pos1 > pos2) ? 1 : 2
        if (difference(pos1, pos2) === 1) {
          type = 1
        }

        this.setState({
          moveItem: {
            open: true,
            type: type,
            item: item
          }
        })
        this.props.triggerPopup(true)
        // }
      }, (res) => {
        // Toastr
        let message
        if (res.response.data.IsStopped === true) message = translation('12347')
        else if (res.response.data.IsReffered === true) message = translation('2704')
        else message = translation('1731')
        window.toastr.error(message, translation('216'))
      })
    }
  }

  getHeaderIcon (info) {
    let imagePath = '/images/svgs/workscreen/'
    switch (info.DictionaryKey) {
      case 395:
        return <img style={{ width: 20, height: 20 }} src={imagePath + 'Draft-order-Black.svg'} />
      case 164:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'neworder.svg'} />
      case 208:
        return <img style={{ width: 16, height: 16 }} src={imagePath + 'coating.svg'} />
      case 163:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'delivered.svg'} />
      case 23:
        return <img style={{ width: 20, height: 20 }} src={imagePath + 'Completed-Black.svg'} />
      case 158:
        return <img style={{ width: 25, height: 25, marginTop: -5 }} src={imagePath + 'sanding.svg'} />
      case 161:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'coating.svg'} />
      case 96:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'pretreatment.svg'} />
      case 160:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'filler.svg'} />
      case 162:
        if (info.StepId === 6) {
          return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'preparing.svg'} />
        } else if (info.StepId === 104) {
          return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'clean.svg'} />
        }
        break
      case 617:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'demount.svg'} />
      case 618:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'reparation.svg'} />
      case 619:
        return <img style={{ width: 20, height: 20, marginTop: -5 }} src={imagePath + 'mount.svg'} />
      default:
        return null
    }
  }

  toggleTasks () {
    let newState = !this.state.showTasks

    this.setState({
      showTasks: newState,
      pinTasks: newState
    })
  }

  toggleTaskPin () {
    let newState = !(window.localStorage.getItem('workscreen_pin_tasks') === 'true' || this.state.pinTasks)
    window.localStorage.setItem('workscreen_pin_tasks', newState ? 'true' : 'false')
    this.setState({
      pinTasks: newState
    })
  }

  renderBoard (val, key) {
    let steps = this.getStepsFromView()
    if (steps.length !== 0) {
      if (steps.indexOf(parseInt(val.Title)) === -1) {
        return null
      }
    }

    this.lastDateUsed = false
    let showOpenTaskIcon = !this.state.showTasks && !this.state.pinTasks
    // const getButton = () => {
    //   let btn = ''
    //   if (val.Orders !== undefined && val.Orders.length > 1) {
    //     // btn = <div className='hint--bottom' aria-label={translation('2317')}><img src='/images/icons/shared-screen.svg' className='Can-Click' onClick={this.pressed.bind(this, key)} /></div>
    //   }
    //   return btn
    // }
    let classnames = 'drag-container'
    if (this.state.isIExplorer || this.state.isFireFox) {
      classnames += ' drag-container-ie'
    } else if (this.state.isEdge) {
      classnames += ' drag-container-edge'
    }
    var headerIcon = this.getHeaderIcon(val)
    var headerText = translation(val.DictionaryKey)
    // var headerButton = getButton()
    const renderOrdersForThis = (val, key1) => {
      return this.renderOrder(key, val, key1)
    }
    const renderAssignOrdersForThis = (val, key1) => {
      return this.renderAssignOrder(key, val, key1)
    }
    var toRender = null
    if (this.state.view === 'workscreen') {
      if (val.Orders === undefined) return null
      if (val.StepId === 1) {
        toRender = val.Orders.sort((a, b) => a.IsAfterNewOrdersGroupingSplit - b.IsAfterNewOrdersGroupingSplit).map(renderOrdersForThis)
      } else {
        toRender = val.Orders.map(renderOrdersForThis)
      }
    }
    if (this.state.view === 'assign') {
      toRender = val.OrderAssignments.map(renderAssignOrdersForThis)
    }
    return (
      <div className={classnames} key={key} ref={'dragparent' + key} data-pos={key}>
        {hasSubscriptionPermission(this.props.auth, 30) && val.Title === '1' && showOpenTaskIcon && (<img onClick={this.toggleTasks} className='otherTasks' src='/images/svgs/othertasks/Task-arrow.svg' />)}
        <h4>{headerIcon} {headerText}</h4>
        <div className='drag-content scrollbar' ref={'drag-container' + key} data-pos={key} data-stepid={val.StepId}>
          {toRender}
        </div>
      </div>
    )
  }

  renderOrder (step, val, key) {
    let openStartStop = false
    let openAction = false
    if (this.state.openAction === val.Id) {
      openAction = true
    }
    if (this.state.openStartStop === val.Id) {
      openStartStop = true
    }
    const hasOpendStatrStop = () => {
      this.setState({
        openStartStop: false
      })
    }
    if (step === 0) {
      // Checks if we logged in as BodyShop

      // let today = moment()
      // let daysDiff = itemDate.diff(today, 'days')
      // let daysDiff = getDateDiff(itemDate)
      if (!this.lastDateUsed && val.IsAfterNewOrdersGroupingSplit) {
        this.lastDateUsed = true

        let label
        switch (this.props.auth.newOrdersGrouping) {
          case 0:
          default:
            label = translation('586')
            break
          case 1:
            label = translation('16583')
            break
        }

        return ([
          <div className='upcomingOrders'>
            {label}
          </div>,
          <Item router={this.props.router} MoveOrders={this.moveOrders} openAction={openAction} openStartStop={openStartStop} hasOpendStatrStop={hasOpendStatrStop} type='0' item={val} key={key} index={key} step={step} completeOrder={this.completeOrder} onStartAsShopLogin={this.onStartAsShopLogin} isEdge={this.state.isEdge} isFireFox={this.state.isFireFox} isIExplorer={this.state.isIExplorer} isTouch={this.state.isTouch} getVerticalScrollOffset={this.getVerticalScrollOffset} getHorizontalScrollOffset={this.getHorizontalScrollOffset} />
        ])
      }
    }
    return <Item
      router={this.props.router}
      MoveOrders={this.moveOrders}
      onMoveSuccess={this.moveOrderSuccess}
      openAction={openAction}
      openStartStop={openStartStop}
      type='0'
      renderTrigger={val.ColoredParts}  // Force item to trigger prop change when ColoredParts change.
      item={val} key={key} index={key} step={step} completeOrder={this.completeOrder}
      onStartAsShopLogin={this.onStartAsShopLogin}
      isEdge={this.state.isEdge} isFireFox={this.state.isFireFox} isIExplorer={this.state.isIExplorer} isTouch={this.state.isTouch} getVerticalScrollOffset={this.getVerticalScrollOffset} getHorizontalScrollOffset={this.getHorizontalScrollOffset}
      hasOpendStatrStop={hasOpendStatrStop} />
  }

  getVerticalScrollOffset (column) {
    let result = 0
    if (column !== undefined && typeof column === 'number') {
      let scrollContainer = this.refs['drag-container' + column]
      if (scrollContainer !== undefined) {
        result = scrollContainer.scrollTop
      }
    }
    return result
  }

  getHorizontalScrollOffset () {
    let result = 0
    let scrollContainer = this.refs['board']
    if (scrollContainer !== undefined) {
      result = scrollContainer.scrollLeft
    }
    return result
  }

  onStartAsShopLogin (data) {
    this.props.triggerPopup(true)
    this.setState({
      loginasmodal: true,
      loginasmodalData: data,
      addPopupShow: false
      // }, () => {
    })
  }

  renderAssignOrder (step, val, key) {
    return (
      <AssignItem router={this.props.router} key={key} item={val} step={step} index={key} onAssignUsers={this.onAssignUsers} getAssignOrderData={this.getAssignOrderData} assignAriaPos={'bottom-right'} useHtmlTitleTag />
    )
  }

  completeOrder (id, fromStep, toStep, step, index) {
    let moveData = {
      Orders: [
        {
          OrderId: id
        }
      ],
      UserId: 0,
      StepFrom: fromStep,
      StepTo: toStep,
      Comment: '',
      FilterSettings: {},
      DontReturnOrders: (toStep === 10)
    }
    // console.log('id, fromStep, toStep, step, index', id, fromStep, toStep, step, index)
    this.props.moveOrder(moveData).then((res) => {
      if (res.data.MoveAll === true) {
        this.setState({
          MoveOrders: {
            ...this.state.MoveOrders,
            open: true,
            OrderIds: res.data.OrderIds,
            FromStep: fromStep,
            ToStep: toStep,
            step: step,
            index: index,
            Id: id
          }
        }, () => {
          // console.log(this.state.MoveOrders)
        })
      } else {
        if (res.data.MoveFailed) {
          this.props.triggerPopup(true)
          this.setState({
            quality: {
              open: true,
              data: [res.data],
              pos: step,
              index: index,
              move: true
            }
          })
        } else {
          if (this.stepHasComments(res.data)) {
            this.props.triggerPopup(true)
            this.setState({
              quality: {
                open: true,
                data: [res.data],
                pos: step,
                index: index,
                move: true
              }
            })
          }
          this.updateRow(res.data.CurrentStepOrders, step, index)
        }
      }
    }, (res) => {
      // Toastr
      let message
      if (res.response.data.IsStopped === true) message = translation('12347')
      else if (res.response.data.IsReffered === true) message = translation('2704')
      else message = translation('1731')
      window.toastr.error(message, translation('216'))
    })
  }

  headerButtonsRight () {
    const renderEmployeePicker = () => {
      if (!hasAccess([5, 7], this.props.auth.user.UserType) || this.state.view !== 'workscreen') return null
      const openLoginAsModal = () => {
        this.setState({ loginasmodal: true })
        this.props.triggerPopup(true)
      }
      var ariaLabel = ''
      if (!this.state.isTouch) ariaLabel = translation('2057')
      return <Icon icon={MainMenuIcons.Customers_Black} onClick={openLoginAsModal} ariaText={ariaLabel} />
    }
    const renderOverviewStatusPicker = () => {
      if (!(hasSubscriptionPermission(this.props.auth, 30) && !hasAccess([4], this.props.auth.user.UserType) && this.state.view === 'workscreen')) return null
      return <OverviewStatusSelection />
    }

    const renderAssignUsers = () => {
      if (!hasAccess([3, 7], this.props.auth.user.UserType)) return null
      const assignUsers = () => {
        if (this.state.view === 'workscreen') {
          this.getAssignOrderData()
        } else {
          this.initOrder()
          setTimeout(() => {
            this.getAssignOrderData([])
          }, 0)
        }
        this.setState({
          view: (this.state.view === 'workscreen') ? 'assign' : 'workscreen',
          showTasks: false
        })
      }
      var ariaLabel = ''
      if (!this.state.isTouch) ariaLabel = translation('2058')
       // <div className='hint--left' aria-label={ariaLabel}><img src='/images/icons/Assign-Black.png' onClick={assignUsers} className='icon' /></div>
      return <Icon icon={AssignmentIcons.Assign_Employee_Black} onClick={assignUsers} ariaText={ariaLabel} />
    }
    const renderSearchFilter = () => {
      if (this.state.view !== 'workscreen') return null

      let filterData = getOrderFilterData({...this.props, source: 'workscreen'})
      let filterActive = false
      // let simplesearch = this.refs.SearchFilter !== undefined ? this.refs.SearchFilter.getWrappedInstance().state.simplesearch : ''

      // let simplesearch = this.refs.SearchFilter !== undefined ? this.refs.SearchFilter.getWrappedInstance().state.simplesearch.value : ''
      let simplesearch = ''
      if (this.refs.SearchFilter !== undefined) {
        let instance = this.refs.SearchFilter.getWrappedInstance()
        if (instance.state !== undefined && instance.state.simplesearch !== undefined && instance.state.simplesearch !== null) {
          simplesearch = instance.state.simplesearch.value
        }
      }
      if (simplesearch === '' || simplesearch === undefined) {
        // let storedSimpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'))
        // if (storedSimpleSearch !== null && storedSimpleSearch.value !== undefined && storedSimpleSearch.value.length > 0) {
        //   simplesearch = storedSimpleSearch.value
        // }
        if (filterData.hasSimpleSearch) {
          simplesearch = filterData.simpleSearch.value
        }
      }
      if (this.refs.SearchFilter !== undefined && isFilterChanged(this.props.auth, simplesearch, this.refs.SearchFilter.getWrappedInstance().props.filter, this.refs.SearchFilter.getWrappedInstance().props.initialFilter)) {
        filterActive = true
      } else {
        // let storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'))
        // if (hasAccess([4], this.props.auth.user.UserType)) {
        //   storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'))
        // } else if (hasAccess([6], this.props.auth.user.UserType)) {
        //   storedFilter = JSON.parse(window.localStorage.getItem('filterWP'))
        // }
        let storedFilter = {...this.props.initialFilter, ...filterData.filter}
        if (isFilterChanged(this.props.auth, simplesearch, storedFilter, this.props.initialFilter)) { // if page refresh
          filterActive = true
        }
      }

      var ariaLabel = ''
      if (!this.state.isTouch) ariaLabel = translation('2048')

      return (
        <div className={filterActive ? 'searchicon filter-active' : 'searchicon'}>
          <Icon icon={FilterIcons.Magnifier_Black} onClick={this.openFilter} injectSvg ariaText={ariaLabel} />
        </div>
      )
    }
    // let searchClass = (isFilterChanged(this.props.auth.user.CustomerId, this.state.searchFilter, this.state.initialSearchFilter)) ? 'active' : ''
    const renderCreateButton = () => {
      if (hasSubscriptionPermission(this.props.auth, 0, 2) && this.state.view === 'workscreen') {
        return (
          <div>
            <Button id='btn-createorder' spacing={0} size='m' style='cta' labelText={translation(21)} onClick={this.showAddPopup} />
            <AddButton id='btn-createorder-phone' spacing={0} size='m' style='cta' onClick={this.showAddPopup} />
          </div>
        )
      }
      return null
    }

    const renderCapacityOverview = () => {
      if (this.state.view !== 'workscreen') return null
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30) || this.props.auth.departmentType !== 1) return null
      return (
        <div className='capacity-overview hide-from-resposive'>
          <Button spacing={0} size='m' style='link' labelText={translation('17912')} onClick={() => this.props.openOverlay('OrderCapacityOverview')} />
        </div>
      )
    }

    return (
      <div>
        <div className='alignHelper' />
        {renderCapacityOverview()}
        {renderOverviewStatusPicker()}
        {renderSearchFilter()}
        {renderEmployeePicker()}
        {hasSubscriptionPermission(this.props.auth, 20, 15) && hasAccessToAssign(this.props.auth) && renderAssignUsers()}
        {renderCreateButton()}
        <NewOrdersModal router={this.props.router}
          show={this.state.addPopupShow}
          onClose={this.showAddPopup}
          bodyShop={this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2} />

        <OrderCapacityOverview />
      </div>
    )
  }

  showAddPopup () {
    if (hasAccess([5, 7], this.props.auth.user.UserType)) {
      this.setState({
        addPopupClickedAsShop: true,
        addPopupShow: false
      }, () => {
        this.onStartAsShopLogin({
          type: 'neworder'
        })
        return false
      })
    }
    let showPopup = this.state.addPopupShow
    this.setState({
      addPopupShow: !showPopup,
      addPopupClickedAsShop: !(this.state.addPopupClickedAsShop && showPopup)
    }, () => {
      // console.log('[NewWorkscreen][showAddPopup]', this.state.addPopupShow, this.state.addPopupClickedAsShop)
      this.props.triggerPopup(this.state.addPopupShow)
    })
  }

  closeAssign () {
    this.setState({
      view: 'workscreen'
    })
  }

  getAssignOrderData (activeEmployees) {
    // Find order ids
    let orderIds = []
    this.state.steps.map((val) => {
      val.Orders.map((v) => {
        orderIds.push(v.Id)
      })
    })
    // Get assign order data
    this.props.getOrderData({
      OrderIds: orderIds,
      UserIds: activeEmployees || this.props.activeEmployees
    }).then((res) => {
      this.setState({
        StepAssignments: res.data.StepAssignments
      })
    }, () => {
      window.toastr.error(translation('1922'), translation('216'))
    })
  }

  onAssignUsers () {
    this.refs.AssignBox.getWrappedInstance().getAssignEmployees()
  }

  closeLoginAs (update, data) {
    if (this._mounted) {
      this.setState({
        loginasmodal: false,
        loginasmodalData: {},
        addPopupClickedAsShop: false
      }, () => {
        if (data === undefined) {
          return
        }
        if (typeof update === 'boolean' && update) {
          let screenView = this.getScreenView(this.props)
          this.setState({
            screenview: screenView,
            steps: [],
            searchFilter: {
              ...this.state.searchFilter,
              SelectedWorkScreenType: parseInt(screenView)
            }
          }, () => {
            // this.initOrder().then(() => {
            if (typeof data !== 'undefined') {
              if (typeof data.type !== 'undefined') {
                // Stop/start - START
                if (data.type === 'stop' || data.type === 'start') {
                  let steps = document.getElementsByClassName('drag-content scrollbar')
                  for (let i = 0; i < steps.length; i++) {
                    if (steps[i].dataset.pos === '' + data.id) {
                      steps[i].scrollTop = data.scrollOffset
                    }
                  }
                  this.setState({
                    openStartStop: data.id
                  })
                  // , () => {
                  //   setTimeout(() => {
                  //     if (this._mounted) {
                  //       this.setState({
                  //         openStartStop: false
                  //       })
                  //     }
                  //   }, 5000)
                  // })
                }
                // Stop/start - END
                // Action - START
                if (data.type === 'action') {
                  this.setState({
                    openAction: data.id
                  }, () => {
                    setTimeout(() => {
                      if (this._mounted) {
                        this.setState({
                          openAction: false
                        })
                      }
                    }, 5000)
                  })
                }
                // Action - END
                // Move - START
                if (data.type === 'move') {
                  if (data.isOneStepMove) {
                    this.initiateMove(data.move.el, data.move.target, data.move.source, data.move.sibling, data.item)
                    return null
                  }
                  this.props.moveOrder(data.move).then((res) => {
                    if (res.data.MoveFailed) {
                      this.props.triggerPopup(true)
                      let quality = data.quality
                      quality.data = res.data
                      this.setState({
                        quality: quality
                      })
                    } else {
                      if (this.stepHasComments(res.data)) {
                        this.props.triggerPopup(true)
                        let quality = data.quality
                        quality.data = res.data
                        this.setState({
                          quality: quality
                        })
                      }
                      if (data.move.CheckOnly) {
                        let item = data.item
                        item.NewStepId = parseInt(data.stepid)
                        item.StepIndex = data.pos1
                        item.ItemIndex = data.index
                        // Difference
                        const difference = (a, b) => {
                          return Math.abs(a - b)
                        }
                        let type = (data.pos1 > data.pos2) ? 1 : 2
                        if (difference(data.pos1, data.pos2) === 1) {
                          type = 1
                        }
                        this.setState({
                          moveItem: {
                            open: true,
                            type: type,
                            item: item
                          }
                        })
                        this.props.triggerPopup(true)
                      } else {
                        // Sometimes data.pos1 and index is undefined?
                        // if (data.pos1 === undefined) {
                        //   data.pos1 = data.move.StepFrom
                        // }
                        // console.log('move order update row data: ', res.data, data)
                        this.updateRow(res.data.CurrentStepOrders, data.pos1, data.index)
                        // let steps = [ data.move.StepFrom, data.move.StepTo ]
                        // this.updateSteps(steps)  // TODO: Færdiggør den her..
                      }
                    }
                  }, (res) => {
                    // Toastr
                    let message
                    if (res.response.data.IsStopped === true) message = translation('12347')
                    else if (res.response.data.IsReffered === true) message = translation('2704')
                    else message = translation('1731')
                    window.toastr.error(message, translation('216'))
                  })
                } // Move - END
                // NEW ORDER - START
                if (data.type === 'neworder') {
                  this.showAddPopup()
                }

                if (data.type === 'task') {
                  this.setState({
                    otherTaskOccurrenceAction: {
                      Id: data.Id,
                      action: data.action
                    },
                    showTasks: true
                  })
                }
              } // Typeof data.type - END
            } // Typeof data - END
            // })
          })
        }
      })
    }
    this.props.triggerPopup(false)
  }

  closeQualityModal () {
    this.props.triggerPopup(false)
    this.setState({
      quality: {
        open: false,
        data: {},
        index: 0,
        pos: 0
      }
    })
  }

  moveOrderSuccess (data, movedOrders) {
    if (data === undefined || movedOrders === undefined) return null
    if (data.MoveFailed === false) {
      let steps = [...this.state.steps]
      let selectedMovedFromStep
      let selectedMovedToStep
      steps.map((step) => {
        if (step.StepId === data.StepTo) {
          selectedMovedToStep = step
        } else if (step.StepId === data.StepFrom) {
          selectedMovedFromStep = step
        }
      })
      let orderIds = movedOrders.map(o => o.OrderId)
      let filter = {
        ...this.state.searchFilter,
        identification: {
          OrderNumbers: orderIds
        }
      }
      let stepsUpdated = false
      // console.log('moveOrderSuccess', filter)
      this.props.getOrdersNew(filter).then((res) => {
        // console.log('MOVE ORDER SUCCESS -> SEARCH SINGLE RESPONSE:', movedOrders, res.data)
        let searchSteps = res.data[0].Steps
        for (let i = 0; i < orderIds.length; i++) {
          let orderId = orderIds[i]
          let foundOrder = null
          for (let s = 0; s < searchSteps.length; s++) {
            if (searchSteps[s].Orders !== undefined && searchSteps[s].Orders.length > 0) {
              for (let o = 0; o < searchSteps[s].Orders.length; o++) {
                if (searchSteps[s].Orders[o].OrderKey === orderId + '') {
                  foundOrder = searchSteps[s].Orders[o]
                  break
                }
              }
            }
            if (foundOrder !== null) break
          }

          if (selectedMovedFromStep !== undefined) {
            // Remove order in 'moved from' step
            let indexInFrom = selectedMovedFromStep.Orders.findIndex(order => order.OrderKey === orderId + '')
            if (indexInFrom >= 0) {
              selectedMovedFromStep.Orders.splice(indexInFrom, 1)
              stepsUpdated = true
            }
          }
          if (foundOrder !== null && selectedMovedToStep !== undefined) {
            // Insert order in 'moved to' step
            selectedMovedToStep.Orders.push(foundOrder)
            foundOrder.mathRandom = Math.random()
            stepsUpdated = true

            let toStepOrderIds = selectedMovedToStep.Orders.map(o => o.Id)
            let step = selectedMovedToStep.StepId

            this.props.getOrderSorting(step, toStepOrderIds).then((res) => {
              selectedMovedToStep.Orders.sort((orderA, orderB) => {
                return res.data.findIndex(id => id === orderA.Id) - res.data.findIndex(id => id === orderB.Id)
              })
              this.setState({
                steps: steps
              })
            })
          } else if (stepsUpdated) {
            this.setState({
              steps: steps
            })
          }
        }
      })

      // Handle additional actions directed by backend.
      // const NONE = 0
      // const CONFIRM_START = 1 // Not used here
      const GOTO_WORKCARD = 2

      const gotoWorkCard = (orderId) => {
        this.props.router.push('/orders/' + orderId + '?notifyPaintNotBooked=1')
      }
      if (data.FrontendActions !== undefined && data.FrontendActions !== null && data.FrontendActions.length > 0) {
        data.FrontendActions.forEach(item => {
          if (item.Action === GOTO_WORKCARD) {
            gotoWorkCard(item.OrderId)
          }
        })
      }
    }
  }

  changeScreen (view, e) {
    e.preventDefault()
    window.localStorage.setItem('workscreen_view', view)
    this.setState({
      screenview: view,
      openDropdownLeft: false
    }, () => {
      this.onSearchSubmit(this.state.filter)
    })
  }

  renderDropdownLeft () {
    const toggleDropdown = (val) => {
      this.setState({
        openDropdownLeft: val
      })
    }
    const closeDropdown = () => {
      this.setState({
        openDropdownLeft: false
      })
    }
    let screenview = this.state.screenview
    return (
      <DropdownBox
        closeDropdown={closeDropdown}
        changeScreen={this.changeScreen.bind(this)}
        toggleDropdown={toggleDropdown}
        screenview={screenview}
        openDropdownLeft={this.state.openDropdownLeft} />
    )
  }

  renderTasks () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null

    let isTasksPined = window.localStorage.getItem('workscreen_pin_tasks') === 'true'
    const handledAction = () => {
      this.setState({
        otherTaskOccurrenceAction: null
      })
    }
    return (
      <div className='mytasks__screen drag-container'>
        <div>
          <h4 onClick={this.toggleTasks}>
            <img className='otherTasks otherTasks--open' src='/images/svgs/menuicons/Task-Black.svg' />
            {translation('1227')}
          </h4>
          <img onClick={this.toggleTaskPin} src={'/images/svgs/othertasks/pen' + (isTasksPined ? '' : '-not') + '-placed.svg'} />
        </div>
        <div className='drag-content scrollbar'>
          <MyTasks IsWorkscreen onStartAsShopLogin={this.onStartAsShopLogin.bind(this)} occurrenceAction={this.state.otherTaskOccurrenceAction} handledAction={handledAction} />
        </div>
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20) && window.localStorage.getItem('workscreen_view') === '7') {
      window.localStorage.setItem('workscreen_view', null)
    }
    // let isTasksPined = (window.localStorage.getItem('workscreen_pin_tasks') === 'true' || this.state.pinTasks)
    let isTasksPined = this.state.pinTasks
    let extraClass = (this.state.view === 'workscreen') ? '' : 'assigningUsers'
    let filterExtraClass = ''
    if (this.state.filterOpen) {
      filterExtraClass += 'open'
    }
    let disableProcessStep = true
    var toRender = null
    if (this.state.view === 'workscreen' && this.state.steps !== undefined) {
      toRender = this.state.steps.map(this.renderBoard)
    }
    if (this.state.view === 'assign') {
      toRender = this.state.StepAssignments.map(this.renderBoard)
    }
    let boardBottom = '0'
    if (this.props.auth.departmentType === 1 && this.state.view === 'assign') {
      boardBottom = '115'
    } else if (this.props.auth.departmentType !== 1 && this.state.view === 'assign') {
      boardBottom = '170'
    }
    // console.log('NewWorkScreen -> render,', this.state)
    return (
      <div className={'work__screen ' + extraClass}>
        <Header router={this.props.router} changeTrigger={Math.random()} renderLeft={this.renderDropdownLeft} renderRight={this.headerButtonsRight} />
        <div className={'filter__wrap ' + filterExtraClass}>
          <div className='right__filter__wrap'>
            <SearchFilter router={this.props.router} ref='SearchFilter' disableProcessStep={disableProcessStep} onSubmit={this.onSearchSubmit} onSimple={this.quickSearch} source='workscreen' />
          </div>
          <div id='board' className='scrollbar right__wrap' style={{bottom: boardBottom + 'px'}} ref='board'>
            <div className='filler' />
            {(this.state.showTasks || this.state.view !== 'assign' && isTasksPined) && this.renderTasks()}
            {toRender}
          </div>
        </div>
        {this.state.view === 'assign' && <AssignBox router={this.props.router} ref='AssignBox' closeAssign={this.closeAssign} onEmployeeChange={this.getAssignOrderData} />}
        {this.state.moveItem.open && (
          <MoveModal router={this.props.router}
            show={this.state.moveItem.open}
            item={this.state.moveItem.item}
            type={this.state.moveItem.type}
            onClose={this.closeMove}
            onMoveOrders={this.moveOrders.bind(this)}
            /* onMoveSuccess={this.MoveMennyOrders.bind(this)}
            onMoveWorkscreen={this.MoveMennyOrders.bind(this)} */ />
        )}
        {hasAccess([5, 7], this.props.auth.user.UserType) && this.state.loginasmodal && (
          <LoginAsModal router={this.props.router}
            data={this.state.loginasmodalData}
            show={this.state.loginasmodal}
            onClose={this.closeLoginAs} />
        )}
        {this.state.quality.open && (
          <QualityCheckModal router={this.props.router}
            show={this.state.quality.open}
            data={this.state.quality.data}
            onMoveSuccess={this.moveOrderSuccess.bind(this)}
            onClose={this.closeQualityModal.bind(this)}
            move={this.state.quality.move}
            onlyProcessComments={this.state.quality.onlyProcessComments} />
        )}
        {this.state.OpenstartModal.open && (
          <MultiStartModal
            show={this.state.OpenstartModal.open}
            onClose={this.closeOrderStart}
            orders={this.state.steps[this.state.OpenstartModal.step].Orders.filter(x => !x.IsStopped)}
            start={this.start.bind(this)}
            move={this.moveOrders.bind(this)}
            step={this.state.OpenstartModal.step + 1} />
        )}
        {this.state.MoveOrders.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'MoveOrders')}>
            <StopOtherOrders Move AllOrders={this.AllOrders.bind(this, 'MoveOrders')} NotAllOrders={this.NotAllOrders.bind(this, 'MoveOrders')} />
          </Portal>
        )}
      </div>
    )
  }

  modalTitle (item) {
    let title = ''
    if (typeof item !== 'undefined') {
      // Model
      if (item.Model) {
        title += item.Model
      }
      // RegNumber
      if (item.RegNumber) {
        if (item.Model) {
          title += ', '
        }
        title += item.RegNumber
      }
      // Title empty
      if (title === '') {
        title += item.Id || item.OrderId
      }
    }

    return title
  }

  AllOrders (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false,
        MoveAll: true
      }
    }, () => {
      this.moveOrders()
    })
  }

  NotAllOrders (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false,
        MoveAll: false
      }
    }, () => {
      this.moveOrders()
    })
  }

  onPortalClose (type) {
    this.props.triggerPopup(false)
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }

  start (OrderIds, UserIds) {
    this.closeOrderStart()
    let Orders = []
    for (let i = 0; i < OrderIds.length; i++) {
      Orders.push({
        OrderId: OrderIds[i],
        WarrantyCode: null,
        PaintThickness: null
      })
    }

    let data = {
      Orders: Orders,
      UserIds: UserIds,
      WorkOnAll: false,
      CheckOnly: false,
      FromMenny: true
    }

    this.props.startOrder(data).then((res) => {
      if (res.data.length > 0 || this.stepHasComments(res.data)) {
        this.props.triggerPopup(true)
        this.setState({
          quality: {
            open: true,
            data: {
              res: res.data,
              WorkOnAll: false,
              UserIds: UserIds
            },
            move: false
          }
        })
      } else {
        // let message = Orders.length > 1 ? translation('13519') : translation('13518')
        // window.toastr.success(message, translation('13424'))
      }
    }, () => {
      let message = Orders.length > 1 ? translation('12337') : translation('1923')
      window.toastr.error(message, translation('216'))
    })
  }

  pressed (key) {
    this.props.triggerPopup(true)
    this.setState({
      OpenstartModal: {
        ...this.state.OpenstartModal,
        open: true,
        step: key
      }
    })
  }

  closeOrderStart () {
    this.props.triggerPopup(false)
    this.setState({
      OpenstartModal: {
        ...this.state.OpenstartModal,
        open: false,
        step: 0
      }
    })
  }
}

Workscreen.propTypes = {
  auth: PropTypes.object.isRequired,
  getOrdersAdvanced: PropTypes.func.isRequired,
  setPrevWorkscreen: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    modalOpen: state.backdrop.modalOpen,
    workscreenOrders: state.orders.workscreenOrders,
    activeEmployees: state.assign.activeEmployees,
    filter: state.orders.filterWorkscreen,
    initialFilter: state.orders.initialFilterWorkscreen
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  getOrdersNew,
  moveOrder,
  logOutAs,
  getOrderData,
  getOrdersAdvanced,
  triggerPopupActionBG,
  startOrder,
  isFilterChanged,
  updateWorkscreenList,
  setPrevWorkscreen,
  setOrdersFilter,
  getOrderSorting,
  openOverlay
})(Workscreen)



// WEBPACK FOOTER //
// ./src/app/pages/NewWorkscreen/index.js